import UploadResume from './suggestions/UploadResume';
import PhoneNumber from './suggestions/PhoneNumber';
import JobHistory from './suggestions/JobHistory';
import Skills from './suggestions/Skills';
import Location from './suggestions/Location';
import DegreeEarned from './suggestions/DegreeEarned';
import VeteranStatus from './suggestions/VeteranStatus';
import LicensesCertifications from './suggestions/LicensesCertifications';

// these match suggestion_key from the suggestions generated by the backend engine
export const UPLOAD_RESUME = 'upload_resume';
export const PHONE_NUMBER = 'phone_number';
export const JOB_HISTORY = 'job_history';
export const SKILLS = 'skills';
export const LOCATION = 'location';
export const DEGREE_EARNED = 'degree_earned';
export const VETERAN_STATUS = 'veteran_status';
export const LICENSES_CERTIFICATIONS = 'licenses_certifications';

// map suggestion_key to the component
export const COMPONENT_MAP = {
  [UPLOAD_RESUME]: UploadResume,
  [PHONE_NUMBER]: PhoneNumber,
  [JOB_HISTORY]: JobHistory,
  [SKILLS]: Skills,
  [LOCATION]: Location,
  [DEGREE_EARNED]: DegreeEarned,
  [VETERAN_STATUS]: VeteranStatus,
  [LICENSES_CERTIFICATIONS]: LicensesCertifications,
};

export default COMPONENT_MAP;
